import React, { Component } from 'react';
import PropTypes from 'prop-types';
import MdArrowForward from 'react-icons/lib/md/arrow-forward';
import moment from 'moment';

import { formatNumber } from '../../../service/market';

import css from '../../../styles/instrument/trades/trades';

class TradeRow extends Component {
    static propTypes = {
        BUYER: PropTypes.string,
        ID: PropTypes.string,
        PRICE: PropTypes.number,
        SELLER: PropTypes.string,
        TIME: PropTypes.number,
        TYPE: PropTypes.string,
        VOLUME: PropTypes.number,
    }

    renderTime() {
        return moment(this.props.TIME).format('HH:mm:ss');
    }

    render() {
        return (
            <tr className={css.tableRow}>
                <td>{this.renderTime()}</td>
                <td>{formatNumber(this.props.PRICE)}</td>
                <td>{formatNumber(this.props.VOLUME, 0)}</td>
                <td>{this.props.SELLER}</td>
                <td className={css.arrow}><MdArrowForward /></td>
                <td>{this.props.BUYER}</td>
            </tr>
        );
    }
}

export default TradeRow;



/** WEBPACK FOOTER **
 ** /src/shared/components/instrument/trades/TradeRow.js
 **/